import { usePageTemplate } from '@bees-web/core/shared/contexts'
import Head from 'next/head'
import Script from 'next/script'
import { FC, ReactNode } from 'react'

import { PageBody, PageContainer } from './MetaPage.styles'

export interface MetaPageProps {
  children?: ReactNode
}

const MetaPage: FC<MetaPageProps> = ({ children = null }: MetaPageProps) => {
  const template = usePageTemplate()
  const { meta = {}, scripts: pageScripts } = template.data
  const title = meta['title'] || ''
  const icon = meta['icon'] || ''
  return (
    <PageContainer className='page-container'>
      {pageScripts?.map((script, index) => (
        <Script key={index} {...script} />
      ))}
      {title && (
        <Head>
          <title>{title}</title>
          <meta property='og:title' content={title} key='title' />
          {icon && (
            <>
              <link rel='icon' type='image/x-icon' href={icon} />
              <link rel='shortcut icon' type='image/x-icon' href={icon} />
            </>
          )}
        </Head>
      )}
      <PageBody data-testid='meta-page-body'>{children}</PageBody>
    </PageContainer>
  )
}

export default MetaPage
